export const uk = {
    'image-preview-header': 'Попередній перегляд зображення',
    'image-preview-header-with-name': 'Попередній перегляд зображення «{name}»',
    'selected-categories-count': {
        one: 'Вибрана {count} тематика',
        some: 'Вибрано {count} тематики',
        many: 'Вибрано {count} тематик',
        none: 'Вибір тематик'
    },
    title: 'Бібліотека зображень'
};
